module.exports = __webpack_public_path__ + "assets/map-marker.7874493e.svg";